import { GRETA_AI_CHAT_SOURCE_TEXT_KEYS } from '../../GretaAIChat.constants'
import { formatGretaAIChatTimeRelative } from '../../GretaAIChat.utils'
import { getIsGretaAIChatFinanceSource } from '../../GretaAIChat.utils.source'

import { GRETA_AI_CHAT_CHAT_LIST_ITEM_SUBTITLE_SEPARATOR } from './GretaAIChatChatListItem.constants'

export function getGretaAIChatChatListItemSubtitle({
  chat,
  isSourceChoiceEnabled,
  locale,
  now,
  t,
}) {
  const isSourceShown =
    isSourceChoiceEnabled || getIsGretaAIChatFinanceSource(chat.source)

  const sourceLabel = isSourceShown
    ? t(GRETA_AI_CHAT_SOURCE_TEXT_KEYS[chat.source].shortKey)
    : null

  const updatedAtLabel = chat.updatedAt
    ? formatGretaAIChatTimeRelative(chat.updatedAt, now, locale)
    : null

  return [sourceLabel, updatedAtLabel]
    .filter(Boolean)
    .join(GRETA_AI_CHAT_CHAT_LIST_ITEM_SUBTITLE_SEPARATOR)
}
